module.exports = __webpack_public_path__ + "static/media/hubspot.4628d688.png";